import React from 'react';
import Mask from 'vanilla-masker';

const ZERO_TO_NINE = Array.from({length: 9}, (_, i) => i);

export const isEmptyObject = (object) => Object.keys(object).length === 0;

export const forwardProps = (Component) => (forwardedProps, position) => {
  const C = React.memo(Component, areEqual(position));
  return (props) => <C {...props} {...forwardedProps} position={position} />;
};

export const testCpf = (cpf) => {
  try {
    if (cpf.length === 14) {
      const cpf_number = Mask.toNumber(cpf)
        .split('')
        .map((v) => parseInt(v));

      if (ZERO_TO_NINE.some((i) => cpf_number.every((v) => v === i))) return false;

      let soma = 0;
      let resto;

      for (let i = 1; i <= 9; i++) soma = soma + cpf_number[i - 1] * (11 - i);
      resto = (soma * 10) % 11;

      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== cpf_number[9]) return false;

      soma = 0;

      for (let i = 1; i <= 10; i++) soma = soma + cpf_number[i - 1] * (12 - i);
      resto = (soma * 10) % 11;

      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== cpf_number[10]) return false;
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const areEqual = (advance = false) => (prevProps, nextProps) => {
  return nextProps.current !== nextProps.position && (advance ? prevProps.isAdvance === nextProps.isAdvance : true);
};

export const parse = {
  pagamento: ({numero, ...cartao}) => {
    return {cartao: {...cartao, numero: Mask.toNumber(numero)}};
  },

  data: ({coberturas, fotos, comprador_bike, ...values}) => {
    const temp = Object.entries(fotos).map(([tipo, file]) => ({tipo, file}));

    const imagens = temp.map(({file}) => file);
    const comprador_imagens = temp.map(({tipo}) => ({tipo}));

    return {
      ...values,
      imagens,
      coberturas: JSON.stringify(coberturas),
      comprador_bike: JSON.stringify(comprador_bike),
      comprador_imagens: JSON.stringify(comprador_imagens),
    };
  },

  config_alteracoes: (array) =>
    Object.entries(array)
      .filter(([_, {modificado}]) => !!modificado)
      .map(([id_conf_fabricante, {descricao}]) => ({id_conf_fabricante, descricao})),
};

export const mask = () => {
  const MONEY_CONFIG = {unit: 'R$', precision: 2, separator: ',', delimiter: '.', suffixUnit: ''};

  return {
    toNumber: (text) => Mask.toNumber(text),

    maskCode: (text) => {
      const value = text.split(' ');
      if (value.length > 1) return value[0] + ' ' + Mask.toPattern(value[1], '999999999');
      else return 'BI- ' + Mask.toPattern(value[0], '999999999');
    },

    maskCVV: (text) => Mask.toPattern(text, '9999'),

    maskMoney: (text) => Mask.toMoney(text, MONEY_CONFIG),

    maskDoc: (type) => (text) => {
      if (type === 'cpf') return Mask.toPattern(text, '999.999.999-99');
      else if (type === 'rg') return Mask.toPattern(text, 'SS.SSS.SSS-S');
      else if (type === 'cnpj') return Mask.toPattern(text, '99.999.999/9999-99');
    },

    maskPhone: (text) => Mask.toPattern(text, '(99) 99999-9999'),

    maskDateFull: (text) => Mask.toPattern(text, '99/99/9999'),
    maskDate: (text) => Mask.toPattern(text, '99/99'),

    maskZipCode: (text) => Mask.toPattern(text, '99999-999'),

    maskSize: (text) => Mask.toPattern(text, '99'),
  };
};
